export const removeNulls = obj => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    // catches null and undefined
    if (value != null && value !== '') {
      acc[key] = value
    }
    return acc
  }, {})
}
